/*eslint-disable */
define(function (require) {
    'use strict';

    var Backbone = require('backbone'),
        $ = require('jquery'),
        _ = require('underscore'),
        BasketSummaryServiceModel = require('./basket-summary-service-model'),
        durationFormatter = require('common/formatter/duration-formatter'),
        priceFormatter = require('common/formatter/price-formatter'),
        xhrUris = require('common/xhr-uris'),
        config = require('common/page-config');


    var BasketSummaryCollection = Backbone.Collection.extend({
        model: BasketSummaryServiceModel,

        initialize: function (options) {
            if (options) {
                _.each(options, _.bind(function (value, key) {
                    this[key] = value;
                }, this))
            }

            // prepare duration labels
            this.durationLabels = this.getDurationLabels();
        },

        getDurationLabels: function () {
            var labels = {
                durationNames: {},
                durationPluralNames: {}
            };

            var singularNames = (config && config.durationNames || config.cms.common.labels.duration.singular);
            var pluralNames = (config && config.durationPluralNames || config.cms.common.labels.duration.plural);

            _.each(singularNames, function (label, index) {
                labels.durationNames[index.toUpperCase()] = label;
            });

            _.each(pluralNames, function (label, index) {
                labels.durationPluralNames[index.toUpperCase()] = label;
            });

            return labels;
        },

        loadBasket: function (basket) {
            var url, collectionModel,
                dataSku;

            this.reset(basket);

            return _.map(basket, _.bind(function (item) {
                url = xhrUris.serviceDetails.replace('{{offerId}}', item.serviceId);

                return $.get(url, _.bind(function (service) {
                    collectionModel = this.get(service.serviceId);

                    collectionModel.set('name', service.name);

                    // update collection service skus with response data service skus
                    _.each(collectionModel.get('skus'), _.bind(function (sku) {
                        dataSku = _.findWhere(service.skus, {skuId: sku.choiceId});
                        // increase service duration
                        sku = _.extend(sku, dataSku || {});
                    }, this));
                }, this));
            }, this));
        },

        getServices: function () {
            return _.map(this.toJSON(), _.bind(function (service) {
                var totalDuration = 0,
                    serviceModel = {
                        serviceId : service.serviceId,
                        name: service.name,
                        canRemoveSkus: service.canRemoveSkus,
                        skus: _.map(service.skus, _.bind(function (sku) {
                            var name = sku.name || sku.employeeCategory;

                            return {
                                skuId: sku.skuId,
                                skuName: name,
                                skuDuration: durationFormatter.format(sku.duration, true, this.durationLabels),
                                price: sku.price === null || sku.price === undefined ? '' : priceFormatter.format({
                                    currencyCode: config.locale.currencyCode,
                                    amount: sku.price
                                }, true),
                                canRemoveSkus: this.canRemoveSkus
                            };
                        }, this))
                    };

                    if (totalDuration > 0) {
                        serviceModel.duration = durationFormatter.format(totalDuration, true, this.durationLabels);
                    }

                return serviceModel;
            }, this));
        },

        getTotals: function () {
            var totals = {},
                skusWithValue = 0,
                totalPrice = {
                    currencyCode: config.locale.currencyCode,
                    amount: 0
                };

            _.each(this.toJSON(), _.bind(function (service) {
                // go through each service sku and increment totals
                _.each(service.skus, _.bind(function (sku) {
                    if (_.isNaN(sku.price) || sku.price === null || sku.price === undefined) {
                        return;
                    }

                    skusWithValue++;
                    totalPrice.amount += sku.price;
                }, this));
            }, this));

            // format total duration and total price
            if (skusWithValue > 0) {
                totals.total = priceFormatter.format(totalPrice, true);
            }

            return totals;
        },

        getUriServices: function () {
            var services = _.map(this.toJSON(), _.bind(function (service) {
                var service = {
                    offerId: service.serviceId,
                    fulfillment: "APPOINTMENT",
                    skus: _.map(service.skus, function (sku) {
                        var skuObj = {
                            skuId: sku.choiceId
                        }

                        if (sku.applicableDays && sku.applicableDays !== '') {
                            skuObj.applicableDays = sku.applicableDays;
                        }

                        return skuObj;
                    })
                };

                return service;
            }, this));

            // Set employee for first service.
            // Do not set on all services, as the employee may not be available
            // for all of them. And availability is provided for employee based
            // on the first service only.
            if (this.employeeId && services.length > 0) {
                services[0].employeeId = this.employeeId;
            }

            return JSON.stringify(services);
        }
    });

    return BasketSummaryCollection;
});
